import React from "react";

export const fileFormatIconsMap: Record<string, React.ReactNode> = {
  docx: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488Z"
        fill="#1B9AEE"
      ></path>
      <path fill="#0042B2" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g opacity="0.8">
        <path
          d="M66.3022 92.72C66.3022 80.344 72.3605 75 80.6622 75C89.1597 75 94.6722 79.66 94.6722 92.33C94.6722 104.71 88.575 110 80.2222 110C71.6765 110 66.3022 105.439 66.3022 92.72ZM113.767 81.3085C109.177 81.3085 106.837 84.7591 106.837 92.3785C106.837 99.4177 109.279 103.639 114.407 103.639C117.582 103.639 119.482 101.991 120.507 100.779L124.607 106.019C123.142 107.766 119.678 109.999 113.767 109.999C103.269 109.999 99.1672 103.005 99.1672 92.8585C99.1672 82.1319 104.297 75.0485 114.307 75.0485C121.047 75.0485 124.07 78.0079 124.997 79.0285L120.117 84.4185C118.993 83.0589 117.381 81.3085 113.767 81.3085ZM61.81 91.7454C61.81 100.433 58.3405 109.515 45.74 109.515L35 109.515L35 75.4854L45.65 75.4854C56.784 75.4854 61.81 80.8697 61.81 91.7454ZM86.959 92.665C86.959 101.062 84.5663 103.835 80.659 103.835C76.5088 103.835 73.969 100.827 73.969 92.235C73.969 83.7882 76.5559 81.165 80.219 81.165C84.3705 81.165 86.959 84.1706 86.959 92.665ZM45.1526 103.402L42.4226 103.402L42.4226 81.6019L45.1126 81.6019C50.5331 81.6019 54.1426 84.2278 54.1426 92.4319C54.1426 98.9838 52.1366 103.402 45.1526 103.402Z"
          fillRule="evenodd"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  ),
  html: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512Z"
        fill="#1B9AEE"
      ></path>
      <path fill="#0042B2" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g opacity="0.8">
        <path
          d="M40 91.24L42.93 94.33L57.8 110L64.54 103.91L52.6003 91.328L64.95 78.68L58.29 72.5L42.97 88.19L40 91.24ZM101.713 72.5L95.0525 78.68L107.398 91.3238L95.4625 103.91L102.202 110L117.073 94.33L120.003 91.24L117.033 88.19L101.713 72.5ZM78.1943 109.978L69.5543 106.918L81.8043 74.0579L90.4443 77.1179L78.1943 109.978Z"
          fillRule="evenodd"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  ),
  csv: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488Z"
        fill="#FFA941"
      ></path>
      <path fill="#FFD591" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g>
        <path
          fill="#FFFFFF"
          d="M51.05 112.7C55.9 112.7 60.05 110.85 63.2 107.2L58.5 101.6C56.75 103.5 54.4 105 51.4 105C46.15 105 42.75 100.7 42.75 93.3C42.75 86.05 46.7 81.75 51.5 81.75C54.15 81.75 56.1 82.95 58 84.65L62.65 78.95C60.1 76.35 56.2 74.1 51.35 74.1C41.9 74.1 33.6 81.2 33.6 93.6C33.6 106.2 41.6 112.7 51.05 112.7ZM80.2 112.7C89.2 112.7 94.4 107.25 94.4 101.05C94.4 95.8 91.65 92.7 87.05 90.85L82.4 89C79.1 87.7 76.8 86.9 76.8 84.8C76.8 82.85 78.45 81.75 81.2 81.75C84.1 81.75 86.4 82.75 88.85 84.6L93.3 79C90.05 75.75 85.5 74.1 81.2 74.1C73.3 74.1 67.7 79.1 67.7 85.35C67.7 90.75 71.35 94 75.25 95.55L80 97.55C83.2 98.9 85.25 99.6 85.25 101.75C85.25 103.75 83.7 105 80.4 105C77.45 105 74 103.45 71.4 101.2L66.3 107.35C70.15 110.9 75.35 112.7 80.2 112.7ZM107 112L117.75 112L128.9 74.75L119.8 74.75L115.6 91.75C114.55 95.75 113.8 99.55 112.7 103.65L112.45 103.65C111.4 99.55 110.65 95.75 109.55 91.75L105.3 74.75L95.85 74.75L107 112Z"
        ></path>
      </g>
    </svg>
  ),
  pdf: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008Z"
        fill="#FF3B53"
      ></path>
      <g opacity="0.4">
        <path fill="#FFFFFF" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      </g>
      <path
        d="M37.5 110L37.5 75L49.57 75C56.7124 75 61.89 77.6415 61.89 85.38C61.89 91.9215 58.4187 97.57 48.11 97.57L45.2 97.57L45.2 110L37.5 110ZM95.2372 91.73C95.2372 100.665 91.665 110 78.6872 110L67.6272 110L67.6272 75L78.5872 75C90.0546 75 95.2372 80.544 95.2372 91.73ZM120.637 90.58L120.637 96.87L109.277 96.87L109.277 110L101.627 110L101.627 75L122.497 75L122.497 81.29L109.277 81.29L109.277 90.58L120.637 90.58ZM78.0922 103.711L75.2722 103.711L75.2722 81.291L78.0422 81.291C83.625 81.291 87.3422 83.9929 87.3422 92.431C87.3422 99.1698 85.2853 103.711 78.0922 103.711ZM45.1953 91.3308L45.1953 81.4408L48.3153 81.4408C52.2386 81.4408 53.9453 82.9856 53.9453 86.4308C53.9453 89.1267 52.8454 91.3308 47.7153 91.3308L45.1953 91.3308Z"
        fillRule="evenodd"
        fill="#FFFFFF"
      ></path>
    </svg>
  ),
  txt: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M30.5077 160L127.826 160C130.101 160 132.194 159.632 134.092 158.88C135.99 158.128 137.706 156.992 139.227 155.488C140.748 153.984 141.944 152.24 142.841 150.24C143.725 148.224 144.167 146.224 144.167 144.224L144.167 45.008L99.1608 0L30.5077 0C28.2327 0 26.1397 0.368 24.2417 1.12C22.3437 1.872 20.6277 3.008 19.1067 4.512C17.5857 6.016 16.3897 7.76 15.4927 9.76C14.6087 11.776 14.1667 13.776 14.1667 15.776L14.1667 144.224C14.1667 146.224 14.6087 148.224 15.4927 150.24C16.3897 152.24 17.5857 153.984 19.1067 155.488C20.6277 156.992 22.3437 158.128 24.2417 158.88C26.1397 159.632 28.2327 160 30.5077 160Z"
        fill="#8C8C8C"
      ></path>
      <g mask="url(#mask-1_4)">
        <path fill="#595959" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      </g>
      <g>
        <path
          fill="#FFFFFF"
          d="M42.5 115L51.45 115L51.45 85.2L61.55 85.2L61.55 77.75L32.45 77.75L32.45 85.2L42.5 85.2L42.5 115ZM63.65 115L73.15 115L76.35 107.75C77.2 105.8 78.05 103.85 78.9 101.55L79.1 101.55C80.1 103.85 80.95 105.8 81.85 107.75L85.3 115L95.25 115L85 96.25L94.6 77.75L85.15 77.75L82.45 84.45C81.7 86.2 80.9 88.15 80.05 90.55L79.85 90.55C78.8 88.15 78 86.2 77.15 84.45L74.15 77.75L64.2 77.75L73.85 95.85L63.65 115ZM107.35 115L116.3 115L116.3 85.2L126.4 85.2L126.4 77.75L97.3 77.75L97.3 85.2L107.35 85.2L107.35 115Z"
        ></path>
      </g>
      <defs>
        <mask id="mask-1_4" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse">
          <path
            d="M30.5077 160L127.826 160C130.101 160 132.194 159.632 134.092 158.88C135.99 158.128 137.706 156.992 139.227 155.488C140.748 153.984 141.944 152.24 142.841 150.24C143.725 148.224 144.167 146.224 144.167 144.224L144.167 45.008L99.1608 0L30.5077 0C28.2327 0 26.1397 0.368 24.2417 1.12C22.3437 1.872 20.6277 3.008 19.1067 4.512C17.5857 6.016 16.3897 7.76 15.4927 9.76C14.6087 11.776 14.1667 13.776 14.1667 15.776L14.1667 144.224C14.1667 146.224 14.6087 148.224 15.4927 150.24C16.3897 152.24 17.5857 153.984 19.1067 155.488C20.6277 156.992 22.3437 158.128 24.2417 158.88C26.1397 159.632 28.2327 160 30.5077 160Z"
            fill="#8C8C8C"
          ></path>
        </mask>
      </defs>
    </svg>
  ),
  ppt: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008Z"
        fill="#FFA941"
      ></path>
      <path fill="#FFD591" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <path
        d="M40 110L40 75L51.84 75C58.8484 75 63.94 77.6415 63.94 85.38C63.94 91.9215 60.5253 97.57 50.41 97.57L47.55 97.57L47.55 110L40 110ZM69.562 110L69.562 75L81.402 75C88.4104 75 93.502 77.6415 93.502 85.38C93.502 91.9215 90.0873 97.57 79.972 97.57L77.112 97.57L77.112 110L69.562 110ZM111.415 81.29L111.415 110L103.865 110L103.865 81.29L95.2745 81.29L95.2745 75L120.005 75L120.005 81.29L111.415 81.29ZM47.5509 91.3308L47.5509 81.4408L50.6109 81.4408C54.4606 81.4408 56.1409 82.9856 56.1409 86.4308C56.1409 89.1267 55.0548 91.3308 50.0209 91.3308L47.5509 91.3308ZM77.1129 91.3308L77.1129 81.4408L80.1729 81.4408C84.0226 81.4408 85.7029 82.9856 85.7029 86.4308C85.7029 89.1267 84.6168 91.3308 79.5829 91.3308L77.1129 91.3308Z"
        fillRule="evenodd"
        fill="#FFFFFF"
      ></path>
    </svg>
  ),
  pptx: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="160"
      viewBox="0 0 130 160"
      fill="none"
    >
      <path
        d="M130 45.008L84.994 0L16.341 0C14.066 0 11.973 0.368 10.075 1.12C8.177 1.872 6.461 3.008 4.94 4.512C3.419 6.016 2.223 7.76 1.326 9.76C0.442 11.776 0 13.776 0 15.776L0 144.224C0 146.224 0.442 148.224 1.326 150.24C2.223 152.24 3.419 153.984 4.94 155.488C6.461 156.992 8.177 158.128 10.075 158.88C11.973 159.632 14.066 160 16.341 160L113.659 160C115.934 160 118.027 159.632 119.925 158.88C121.823 158.128 123.539 156.992 125.06 155.488C126.581 153.984 127.777 152.24 128.674 150.24C129.558 148.224 130 146.224 130 144.224L130 45.008Z"
        fill="#FFA941"
      ></path>
      <path fill="#FFD591" d="M95 45L130 45L85 0L85 35C85 40.5228 89.4771 45 95 45"></path>
    </svg>
  ),
  xls: (
    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="256" height="256">
      <defs>
        <filter id="softBlur" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="80"></feGaussianBlur>
        </filter>
        <linearGradient id="fileGreen" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00C853"></stop>
          <stop offset="100%" stopColor="#009624"></stop>
        </linearGradient>
      </defs>
      <rect
        x="80"
        y="80"
        width="864"
        height="864"
        rx="160"
        fill="#00C853"
        opacity="0.12"
        filter="url(#softBlur)"
      ></rect>
      <ellipse
        cx="512"
        cy="900"
        rx="220"
        ry="40"
        fill="#009624"
        opacity="0.35"
        filter="url(#softBlur)"
      ></ellipse>
      <path
        d="M300 160h320l200 200v400a64 64 0 0 1-64 64H300a64 64 0 0 1-64-64V224a64 64 0 0 1 64-64z"
        fill="url(#fileGreen)"
      ></path>
      <path d="M620 160v136a64 64 0 0 0 64 64h136" fill="#FFFFFF" opacity="0.9"></path>
      <text
        x="530"
        y="680"
        textAnchor="middle"
        fontSize="150"
        fontWeight="800"
        fill="#FFFFFF"
        fontFamily="Arial Black, Helvetica, sans-serif"
      >
        XLS
      </text>
    </svg>
  ),
  xlsx: (
    <svg width="160" height="160" viewBox="0 0 160 160" fill="none">
      <path
        d="M31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0Z"
        fill="#15AD31"
      ></path>
      <path
        d="M80 82.393L88.5545 70L100.641 70L86.1515 91.3075L102.5 114.995L89.9495 114.995L80 100.357L71.4455 115L57.5 115L73.8485 91.312L59.3585 70L71.4455 70L80 82.393Z"
        fill="#EDFFED"
      ></path>
      <g opacity="0.4">
        <path fill="#CAFAC8" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      </g>
    </svg>
  ),
  json: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488Z"
        fill="#FFA941"
      ></path>
      <path fill="#FFD591" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g>
        <path
          fill="#FFFFFF"
          d="M33.05 112.7C41.4 112.7 45.25 106.7 45.25 99.4L45.25 74.75L36.3 74.75L36.3 98.7C36.3 103.55 34.75 105 31.85 105C30.05 105 28.15 103.85 26.85 101.3L20.8 105.85C23.45 110.45 27.25 112.7 33.05 112.7ZM61.4 112.7C69.15 112.7 73.25 108.65 73.25 103.4C73.25 98.25 69.3 96.2 65.75 94.85C62.8 93.8 60.35 93.15 60.35 91.45C60.35 90.1 61.3 89.4 63.35 89.4C65.2 89.4 67.2 90.35 69.25 91.8L73.2 86.5C70.8 84.65 67.5 82.85 63.05 82.85C56.4 82.85 52.05 86.5 52.05 91.85C52.05 96.6 55.9 98.9 59.3 100.25C62.2 101.4 64.95 102.2 64.95 103.9C64.95 105.3 63.95 106.15 61.6 106.15C59.35 106.15 57 105.1 54.4 103.15L50.45 108.7C53.35 111.1 57.7 112.7 61.4 112.7ZM90.75 112.7C97.95 112.7 104.65 107.2 104.65 97.75C104.65 88.35 97.95 82.85 90.75 82.85C83.5 82.85 76.8 88.35 76.8 97.75C76.8 107.2 83.5 112.7 90.75 112.7ZM90.75 105.5C87.4 105.5 85.9 102.5 85.9 97.75C85.9 93.05 87.4 90.05 90.75 90.05C94.05 90.05 95.55 93.05 95.55 97.75C95.55 102.5 94.05 105.5 90.75 105.5ZM110.25 112L119.15 112L119.15 93C120.85 91.35 122.05 90.45 124.05 90.45C126.3 90.45 127.35 91.55 127.35 95.5L127.35 112L136.25 112L136.25 94.4C136.25 87.3 133.6 82.85 127.4 82.85C123.55 82.85 120.65 84.8 118.3 87.1L118.15 87.1L117.5 83.55L110.25 83.55L110.25 112Z"
        ></path>
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76Z"
        fill="#7C83EB"
      ></path>
      <path fill="#C3C6F3" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g>
        <path
          fill="#FFFFFF"
          d="M44.3 112L52.3 112L52.3 99.25C52.3 95.55 51.6 90 51.15 86.35L51.35 86.35L54.35 95.25L59.4 108.85L64.3 108.85L69.3 95.25L72.4 86.35L72.65 86.35C72.15 90 71.45 95.55 71.45 99.25L71.45 112L79.6 112L79.6 74.75L69.9 74.75L64.2 90.85C63.5 93 62.9 95.35 62.15 97.6L61.9 97.6C61.2 95.35 60.6 93 59.85 90.85L53.95 74.75L44.3 74.75L44.3 112ZM88.15 112L99.35 112C110.2 112 117.7 106.15 117.7 93.2C117.7 80.25 110.2 74.75 98.85 74.75L88.15 74.75L88.15 112ZM97.1 104.8L97.1 81.9L98.3 81.9C104.3 81.9 108.55 84.35 108.55 93.2C108.55 102.05 104.3 104.8 98.3 104.8L97.1 104.8Z"
        ></path>
      </g>
    </svg>
  ),
  rtf: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76Z"
        fill="#7C83EB"
      ></path>
      <path fill="#C3C6F3" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g>
        <path
          fill="#FFFFFF"
          d="M44.25 91.85L44.25 81.85L48.25 81.85C52.5 81.85 54.8 83 54.8 86.5C54.8 90 52.5 91.85 48.25 91.85L44.25 91.85ZM55.4 112L65.4 112L57.1 97.25C60.95 95.45 63.5 91.95 63.5 86.5C63.5 77.5 56.9 74.75 48.95 74.75L35.3 74.75L35.3 112L44.25 112L44.25 98.9L48.55 98.9L55.4 112ZM77.9 112L86.85 112L86.85 82.2L96.95 82.2L96.95 74.75L67.85 74.75L67.85 82.2L77.9 82.2L77.9 112ZM102.7 112L111.65 112L111.65 97.8L124.35 97.8L124.35 90.35L111.65 90.35L111.65 82.2L126.45 82.2L126.45 74.75L102.7 74.75L102.7 112Z"
        ></path>
      </g>
    </svg>
  ),
  xml: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
    >
      <path
        d="M31.341 0C29.066 0 26.973 0.368 25.075 1.12C23.177 1.872 21.461 3.008 19.94 4.512C18.419 6.016 17.223 7.76 16.326 9.76C15.442 11.776 15 13.776 15 15.776L15 144.224C15 146.224 15.442 148.224 16.326 150.24C17.223 152.24 18.419 153.984 19.94 155.488C21.461 156.992 23.177 158.128 25.075 158.88C26.973 159.632 29.066 160 31.341 160L128.659 160C130.934 160 133.027 159.632 134.925 158.88C136.823 158.128 138.539 156.992 140.06 155.488C141.581 153.984 142.777 152.24 143.674 150.24C144.558 148.224 145 146.224 145 144.224L145 45.008L99.994 0L31.341 0Z"
        fill="#1B9AEE"
      ></path>
      <path fill="#0042B2" d="M110 45L145 45L100 0L100 35C100 40.5228 104.477 45 110 45"></path>
      <g opacity="0.8">
        <path
          d="M39.1 110L45.5 98.65L52.05 110L61.2001 110L50 92.1L60.6 74.95L51.8 74.95L46.2001 85.7L40.1 74.95L30.9 74.95L41.55 92.1L30.3 110L39.1 110ZM72.65 110L72.65 84.05L72.95 84.05L80.65 105.8L86.95 105.8L94.75 84.05L94.95 110L102.25 110L102.25 74.95L90.8 74.95L84.25 93.85L84.05 93.85L77.4 74.95L65.65 74.95L65.65 110L72.65 110ZM131 110L110.45 110L110.45 74.95L118.1 74.95L118.1 103.7L131 103.7L131 110Z"
          fillRule="evenodd"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  ),
};

export interface FileFormatIconProps {
  format?: string;
  className?: string;
}

export const FileFormatIcon: React.FC<FileFormatIconProps> = ({ format, className, ...props }) => {
  if (!format) {
    return null;
  }

  const icon = fileFormatIconsMap[format.toLowerCase()];

  if (!icon) {
    return null;
  }

  const iconElement = icon as React.ReactElement<
    { className?: string } & React.SVGAttributes<SVGSVGElement>
  >;

  return React.cloneElement(iconElement, {
    className: `${iconElement.props?.className || ""} ${className || ""}`.trim(),
    ...props,
  });
};
